import axios from '|/helpers/axios';

export const GAP_WAIVER_ENDPOINTS = {
  GET_GAP_WAIVER: `${process.env.API_URL}/api/v1/gapwaiver/available`,
  GET_ELIGIBILITY: `${process.env.API_URL}/api/v1/gapwaiver/eligible`,
  SELECT: `${process.env.API_URL}/api/v1/gapwaiver/select`,
  DECLINE: `${process.env.API_URL}/api/v1/gapwaiver/decline`,
  RESET: `${process.env.API_URL}/api/v1/gapwaiver/reset`
};

export interface GapWaiverEligibilityResponse {
  isEligible: boolean;
  reason?: string;
}

interface Financing {
  downPayment: number;
  modifiedDownPayment: number;
  downPaymentDifference: number;
  annualPercentageRate: number;
  monthlyPayment: number;
  modifiedMonthlyPayment: number;
  monthlyPaymentDifference: number;
  termLength: number;
  termLengthDifference: number;
}

export interface GapWaiverResponse {
  isAvailable: boolean;
  isApplied: boolean;
  isSelected: boolean;
  price: number;
  vehicleId?: number;
  financing: Financing;
}

export const getGapWaiver = async (abortSignal: AbortSignal) =>
  axios
    .get<GapWaiverResponse>(GAP_WAIVER_ENDPOINTS.GET_GAP_WAIVER, {
      signal: abortSignal
    })
    .then(res => res.data);

export const getGapWaiverEligibility = async (abortSignal: AbortSignal) =>
  axios
    .get<GapWaiverEligibilityResponse>(GAP_WAIVER_ENDPOINTS.GET_ELIGIBILITY, {
      signal: abortSignal
    })
    .then(res => res.data);

export const addGapWaiver = async (abortSignal: AbortSignal) =>
  axios
    .post<never>(GAP_WAIVER_ENDPOINTS.SELECT, undefined, {
      signal: abortSignal
    })
    .then(res => res.data);

export const declineGapWaiver = async (abortSignal: AbortSignal) =>
  axios
    .post<never>(GAP_WAIVER_ENDPOINTS.DECLINE, undefined, {
      signal: abortSignal
    })
    .then(res => res.data);

export const resetGapWaiver = async (abortSignal: AbortSignal) =>
  axios
    .post<never>(GAP_WAIVER_ENDPOINTS.RESET, undefined, {
      signal: abortSignal
    })
    .then(res => res.data);
